<template>
  <el-dialog
      :visible="true"
      @close="$emit('close')"
      width="520px"
      custom-class="theme-dialog"
      :title="question.content.text"
  >
<!--    <div class="vote-question-title">-->
<!--      <div>-->
<!--        <span>{{ question.num }}.</span>-->
<!--      </div>-->
<!--      <div>-->
<!--        <div v-html="question.content.richText"></div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="vote-answer" style="margin-top: 0;">
      <choice-vote-content :items="items" :show-count="-1"/>
    </div>
  </el-dialog>
</template>

<script>

import CustomProgress from '@/vote/CustomProgress.vue'
import ChoiceVoteContent from '@/vote/ChoiceVoteContent.vue'

export default {
  name: 'ChoiceMoreRank',
  components: { ChoiceVoteContent, CustomProgress },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    question: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>

</style>